import { add, format } from "date-fns";

import {
  Expiration,
  intervals,
} from "@/components/pages_logged_in/certifications/types";
import { ExpirationInterval, ExpirationType } from "@/graphql";

export function formatValidity(expiration: Expiration): string | undefined {
  if (expiration.type === ExpirationType.Relative) {
    return `Valid from ${format(new Date(), "MMM d, yyyy")} until ${format(
      add(new Date(), {
        [intervals[expiration.interval]]: expiration.value,
      }),
      "MMM d, yyyy",
    )}`;
  }
  if (expiration.type === ExpirationType.Absolute && expiration.value) {
    return `Valid until ${format(new Date(expiration.value), "MMM d, yyyy")}`;
  }
  return undefined;
}

export function toExpiration(
  expirationType: ExpirationType,
  expirationInterval?: ExpirationInterval | null,
  expirationValue?: number | null,
  expirationDate?: string | null,
): Expiration {
  switch (expirationType) {
    case ExpirationType.NoExpiration:
      return {
        type: ExpirationType.NoExpiration,
      };
    case ExpirationType.Relative:
      return {
        type: ExpirationType.Relative,
        interval: expirationInterval!,
        value: expirationValue || 0,
      };
    case ExpirationType.Absolute:
      return {
        type: ExpirationType.Absolute,
        value: expirationDate || "",
      };
    default:
      throw new Error(`Invalid expiration type: ${expirationType}`);
  }
}
